// extracted by mini-css-extract-plugin
export var accountData = "auth-forms-module--account-data--3wcpH";
export var authForm = "auth-forms-module--auth-form--H8-Li";
export var avatarUpload = "auth-forms-module--avatar-upload--8+6Eq";
export var btnPrimary = "auth-forms-module--btn-primary--kQ-95";
export var button = "auth-forms-module--button--0GET3";
export var checkbox = "auth-forms-module--checkbox--wZM3P";
export var contactForm = "auth-forms-module--contactForm--IOFoK";
export var form = "auth-forms-module--form--pp7ff";
export var formField = "auth-forms-module--form-field--rpizR";
export var formFieldInput = "auth-forms-module--form-field-input--aP08C";
export var formFieldLabel = "auth-forms-module--form-field-label--w5uN5";
export var guideHelpBtn = "auth-forms-module--guide-help-btn--6RPwl";
export var guideHelpRow = "auth-forms-module--guide-help-row--nPnXK";
export var input = "auth-forms-module--input--dQm61";
export var linkPass = "auth-forms-module--linkPass--ed+wo";
export var newsletterForm = "auth-forms-module--newsletter-form--GMVCh";